import * as api from '../api/buildingpermit';
import { makeApiActionCreatorV3 } from '@actions/utils';

const namespace = 'APPRAISAL/BUILDING_PERMIT';

export const BUILDING_PERMIT_SEARCH_PARAM_RESET = `${namespace}/BUILDING_PERMIT_SEARCH_PARAM_RESET`;

export const resetBuildingPermitSearchParam = () => ({
  type: BUILDING_PERMIT_SEARCH_PARAM_RESET,
});

export const BUILDING_PERMIT_SEARCH_PARAM_SET = `${namespace}/BUILDING_PERMIT_SEARCH_PARAM_SET`;

export const setBuildingPermitSearchParam = searchParamID => ({
  type: BUILDING_PERMIT_SEARCH_PARAM_SET,
  searchParamID,
});

export const BUILDING_PERMIT_SEARCH_PARAMS_FETCH_START = `${namespace}/BUILDING_PERMIT_SEARCH_PARAMS_FETCH_START`;
export const BUILDING_PERMIT_SEARCH_PARAMS_FETCH_SUCCESS = `${namespace}/BUILDING_PERMIT_SEARCH_PARAMS_FETCH_SUCCESS`;
export const BUILDING_PERMIT_SEARCH_PARAMS_FETCH_ERROR = `${namespace}/BUILDING_PERMIT_SEARCH_PARAMS_FETCH_ERROR`;

export const fetchBuildingPermitSearchParams = makeApiActionCreatorV3(
  api.fetchBuildingPermitSearchParams,
  BUILDING_PERMIT_SEARCH_PARAMS_FETCH_START,
  BUILDING_PERMIT_SEARCH_PARAMS_FETCH_SUCCESS,
  BUILDING_PERMIT_SEARCH_PARAMS_FETCH_ERROR,
);

export const SEARCH_CONFIG_RESULTS_FETCH_START = `${namespace}/SEARCH_CONFIG_RESULTS_FETCH_START`;
export const SEARCH_CONFIG_RESULTS_FETCH_SUCCESS = `${namespace}/SEARCH_CONFIG_RESULTS_FETCH_SUCCESS`;
export const SEARCH_CONFIG_RESULTS_FETCH_ERROR = `${namespace}/SEARCH_CONFIG_RESULTS_FETCH_ERROR`;

export const fetchSearchConfigResults = makeApiActionCreatorV3(
  api.fetchSearchConfigResults,
  SEARCH_CONFIG_RESULTS_FETCH_START,
  SEARCH_CONFIG_RESULTS_FETCH_SUCCESS,
  SEARCH_CONFIG_RESULTS_FETCH_ERROR,
);

export const BUILDING_PERMIT_SEARCH_CONFIG_FETCH_START = `${namespace}/BUILDING_PERMIT_SEARCH_CONFIG_FETCH_START`;
export const BUILDING_PERMIT_SEARCH_CONFIG_FETCH_SUCCESS = `${namespace}/BUILDING_PERMIT_SEARCH_CONFIG_FETCH_SUCCESS`;
export const BUILDING_PERMIT_SEARCH_CONFIG_FETCH_ERROR = `${namespace}/BUILDING_PERMIT_SEARCH_CONFIG_FETCH_ERROR`;

export const fetchBuildingPermitSearchConfig = makeApiActionCreatorV3(
  api.fetchBuildingPermitSearchConfig,
  BUILDING_PERMIT_SEARCH_CONFIG_FETCH_START,
  BUILDING_PERMIT_SEARCH_CONFIG_FETCH_SUCCESS,
  BUILDING_PERMIT_SEARCH_CONFIG_FETCH_ERROR,
);

export const BUILDING_PERMIT_CODES_FETCH_START = `${namespace}/BUILDING_PERMIT_CODES_FETCH_START`;
export const BUILDING_PERMIT_CODES_FETCH_SUCCESS = `${namespace}/BUILDING_PERMIT_CODES_FETCH_SUCCESS`;
export const BUILDING_PERMIT_CODES_FETCH_ERROR = `${namespace}/BUILDING_PERMIT_CODES_FETCH_ERROR`;

export const fetchBuildingPermitCodes = makeApiActionCreatorV3(
  api.fetchBuildingPermitCodes,
  BUILDING_PERMIT_CODES_FETCH_START,
  BUILDING_PERMIT_CODES_FETCH_SUCCESS,
  BUILDING_PERMIT_CODES_FETCH_ERROR,
);

export const BUILDING_PERMIT_SEARCH_PARAM_INSERT_START = `${namespace}/BUILDING_PERMIT_SEARCH_PARAM_INSERT_START`;
export const BUILDING_PERMIT_SEARCH_PARAM_INSERT_SUCCESS = `${namespace}/BUILDING_PERMIT_SEARCH_PARAM_INSERT_SUCCESS`;
export const BUILDING_PERMIT_SEARCH_PARAM_INSERT_ERROR = `${namespace}/BUILDING_PERMIT_SEARCH_PARAM_INSERT_ERROR`;

export const insertBuildingPermitSearchParam = makeApiActionCreatorV3(
  api.insertBuildingPermitSearchParam,
  BUILDING_PERMIT_SEARCH_PARAM_INSERT_START,
  BUILDING_PERMIT_SEARCH_PARAM_INSERT_SUCCESS,
  BUILDING_PERMIT_SEARCH_PARAM_INSERT_ERROR,
);

export const BUILDING_PERMIT_SEARCH_PARAM_UPDATE_START = `${namespace}/BUILDING_PERMIT_SEARCH_PARAM_UPDATE_START`;
export const BUILDING_PERMIT_SEARCH_PARAM_UPDATE_SUCCESS = `${namespace}/BUILDING_PERMIT_SEARCH_PARAM_UPDATE_SUCCESS`;
export const BUILDING_PERMIT_SEARCH_PARAM_UPDATE_ERROR = `${namespace}/BUILDING_PERMIT_SEARCH_PARAM_UPDATE_ERROR`;

export const updateBuildingPermitSearchParam = makeApiActionCreatorV3(
  api.updateBuildingPermitSearchParam,
  BUILDING_PERMIT_SEARCH_PARAM_UPDATE_START,
  BUILDING_PERMIT_SEARCH_PARAM_UPDATE_SUCCESS,
  BUILDING_PERMIT_SEARCH_PARAM_UPDATE_ERROR,
);

export const BUILDING_PERMIT_SEARCH_PARAM_DELETE_START = `${namespace}/BUILDING_PERMIT_SEARCH_PARAM_DELETE_START`;
export const BUILDING_PERMIT_SEARCH_PARAM_DELETE_SUCCESS = `${namespace}/BUILDING_PERMIT_SEARCH_PARAM_DELETE_SUCCESS`;
export const BUILDING_PERMIT_SEARCH_PARAM_DELETE_ERROR = `${namespace}/BUILDING_PERMIT_SEARCH_PARAM_DELETE_ERROR`;

export const deleteBuildingPermitSearchParam = makeApiActionCreatorV3(
  api.deleteBuildingPermitSearchParam,
  BUILDING_PERMIT_SEARCH_PARAM_DELETE_START,
  BUILDING_PERMIT_SEARCH_PARAM_DELETE_SUCCESS,
  BUILDING_PERMIT_SEARCH_PARAM_DELETE_ERROR,
);

export const BUILDING_PERMIT_SEARCH_PARAM_DUPLICATE_START = `${namespace}/BUILDING_PERMIT_SEARCH_PARAM_DUPLICATE_START`;
export const BUILDING_PERMIT_SEARCH_PARAM_DUPLICATE_SUCCESS = `${namespace}/BUILDING_PERMIT_SEARCH_PARAM_DUPLICATE_SUCCESS`;
export const BUILDING_PERMIT_SEARCH_PARAM_DUPLICATE_ERROR = `${namespace}/BUILDING_PERMIT_SEARCH_PARAM_DUPLICATE_ERROR`;

export const duplicateBuildingPermitSearchParam = makeApiActionCreatorV3(
  api.duplicateBuildingPermitSearchParam,
  BUILDING_PERMIT_SEARCH_PARAM_DUPLICATE_START,
  BUILDING_PERMIT_SEARCH_PARAM_DUPLICATE_SUCCESS,
  BUILDING_PERMIT_SEARCH_PARAM_DUPLICATE_ERROR,
);

export const BUILDING_PERMIT_SEARCH_START = `${namespace}/BUILDING_PERMIT_SEARCH_START`;
export const BUILDING_PERMIT_SEARCH_SUCCESS = `${namespace}/BUILDING_PERMIT_SEARCH_SUCCESS`;
export const BUILDING_PERMIT_SEARCH_ERROR = `${namespace}/BUILDING_PERMIT_SEARCH_ERROR`;

export const searchBuildingPermit = makeApiActionCreatorV3(
  api.searchBuildingPermit,
  BUILDING_PERMIT_SEARCH_START,
  BUILDING_PERMIT_SEARCH_SUCCESS,
  BUILDING_PERMIT_SEARCH_ERROR,
);

export const BUILDING_PERMIT_MASS_UPDATE_STATUS_START = `${namespace}/BUILDING_PERMIT_MASS_UPDATE_STATUS_START`;
export const BUILDING_PERMIT_MASS_UPDATE_STATUS_SUCCESS = `${namespace}/BUILDING_PERMIT_MASS_UPDATE_STATUS_SUCCESS`;
export const BUILDING_PERMIT_MASS_UPDATE_STATUS_ERROR = `${namespace}/BUILDING_PERMIT_MASS_UPDATE_STATUS_ERROR`;

export const massUpdateStatusBuildingPermit = makeApiActionCreatorV3(
  api.massUpdateStatusBuildingPermit,
  BUILDING_PERMIT_MASS_UPDATE_STATUS_START,
  BUILDING_PERMIT_MASS_UPDATE_STATUS_SUCCESS,
  BUILDING_PERMIT_MASS_UPDATE_STATUS_ERROR,
);

export const BUILDING_PERMIT_MASS_REMATCH_START = `${namespace}/BUILDING_PERMIT_MASS_REMATCH_START`;
export const BUILDING_PERMIT_MASS_REMATCH_SUCCESS = `${namespace}/BUILDING_PERMIT_MASS_REMATCH_SUCCESS`;
export const BUILDING_PERMIT_MASS_REMATCH_ERROR = `${namespace}/BUILDING_PERMIT_MASS_REMATCH_ERROR`;

export const massRematchBuildingPermit = makeApiActionCreatorV3(
  api.massRematchBuildingPermit,
  BUILDING_PERMIT_MASS_REMATCH_START,
  BUILDING_PERMIT_MASS_REMATCH_SUCCESS,
  BUILDING_PERMIT_MASS_REMATCH_ERROR,
);

export const BUILDING_PERMIT_MASS_REMATCH_LOGS_FETCH_START = `${namespace}/BUILDING_PERMIT_MASS_REMATCH_LOGS_FETCH_START`;
export const BUILDING_PERMIT_MASS_REMATCH_LOGS_FETCH_SUCCESS = `${namespace}/BUILDING_PERMIT_MASS_REMATCH_LOGS_FETCH_SUCCESS`;
export const BUILDING_PERMIT_MASS_REMATCH_LOGS_FETCH_ERROR = `${namespace}/BUILDING_PERMIT_MASS_REMATCH_LOGS_FETCH_ERROR`;

export const fetchMassRematchLogs = makeApiActionCreatorV3(
  api.fetchMassRematchLogs,
  BUILDING_PERMIT_MASS_REMATCH_LOGS_FETCH_START,
  BUILDING_PERMIT_MASS_REMATCH_LOGS_FETCH_SUCCESS,
  BUILDING_PERMIT_MASS_REMATCH_LOGS_FETCH_ERROR,
);

export const MASS_INACTIVE_BUILDING_PERMITS_START = `${namespace}/MASS_INACTIVE_BUILDING_PERMITS_START`;
export const MASS_INACTIVE_BUILDING_PERMITS_SUCCESS = `${namespace}/MASS_INACTIVE_BUILDING_PERMITS_SUCCESS`;
export const MASS_INACTIVE_BUILDING_PERMITS_ERROR = `${namespace}/MASS_INACTIVE_BUILDING_PERMITS_ERROR`;

export const massInactiveBuildingPermit = makeApiActionCreatorV3(
  api.massInactiveBuildingPermit,
  MASS_INACTIVE_BUILDING_PERMITS_START,
  MASS_INACTIVE_BUILDING_PERMITS_SUCCESS,
  MASS_INACTIVE_BUILDING_PERMITS_ERROR,
);

export const CHANGE_PAGE = `${namespace}/CHANGE_PAGE`;
export const changePage = page => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;
export const changeRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});
